import { PatientPortalUserSummary } from '../../models/activity-log';
import { UserPatientRelationshipType } from '../../models/user-patient-relationship-type';

/** What a self-access reads as: the actor is the subject patient, not a proxy for them. */
const PATIENT_ROLE_LABEL = 'Patient';

/**
 * The acting portal user's relationship to the subject patient, as the detail screens' "Performed
 * By" line and subtitle render it.
 *
 * Self-access reads as "Patient"; every other relationship shows its own label, so a proxy read is
 * never mistaken for the patient's own. Both disclosure detail screens show the same event from the
 * same endpoint, so the rule lives here rather than being restated per screen — a divergence would
 * mean one audit surface naming a relationship the other doesn't.
 *
 * Deliberately *not* shared with `ActivityLogs.buildActorRole`: the feed row works off
 * `AuditEventSummary` (a different contract), covers admin actors as well as portal ones, and
 * renders a proxy as "Proxy ({relationship})" to disambiguate a row seen out of context. That is a
 * different rule, not a copy of this one.
 */
export function getActorRoleLabel(actor: PatientPortalUserSummary | null | undefined): string {
  if (!actor) {
    return '';
  }
  return actor.patientRelationshipTypeId === UserPatientRelationshipType.Self
    ? PATIENT_ROLE_LABEL
    : actor.patientRelationshipType;
}
